import { Resources } from "../Resources";
import frame from "./../../res/honeyFrame.png";
import honeyJar from "./../../res/jar.png";
import coin from "./../../res/coin.png";
import sugar from "./../../res/sugar.png";
import box from "./../../res/box.png";
import nuc from "./../../res/nuc.png";
import beePackage from "./../../res/package.png";
import bee from "./../../res/bee.png";
import smoker from "./../../res/smoker.png";
export default class GainedItem {
  constructor() {
    if (GainedItem._instance) {
      return GainedItem._instance;
    }
    GainedItem._instance = this;
    this.currentItems = [];
    this.displaying = false;
    this.noti = document.getElementById("gained-item");
    this.noti.style.bottom = "-200px";
    this.noti.style.display = "block";
    this.noti.classList.add("showingGained");
  }

  addItem(item) {
    console.log("adding item to gainedItem array: ", item);
    this.currentItems.push(item);
    if (!this.displaying) {
      this.displayItem();
    }
  }
  displayItem() {
    this.noti.classList.add("showingGained");
    let toDisplay = 0;
    //find out how many times this same item is going to be displayed
    for (let i = 0; i < this.currentItems.length; i++) {
      if (this.currentItems[i] == this.currentItems[0] && i !== 0) {
        toDisplay++;
      }
    }

    console.log(
      "displaying gainedItem, currentItems: ",
      this.currentItems,
      " todisplay: ",
      toDisplay
    );
    this.displaying = true;
    if (this.currentItems[0].includes("chievement")) {
      Resources.Won.play();
    }
    let image = null;
    if (this.currentItems[0].includes("rames")) {
      image = frame;
    } else if (this.currentItems[0].includes("Jar")) {
      image = honeyJar;
    } else if (this.currentItems[0].includes("$")) {
      image = coin;
    } else if (this.currentItems[0].includes("ugar")) {
      image = sugar;
    } else if (this.currentItems[0].includes("ox")) {
      image = box;
    } else if (this.currentItems[0].includes("uc")) {
      image = nuc;
    } else if (this.currentItems[0].includes("ueen")) {
      image = bee;
    } else if (this.currentItems[0].includes("ackage")) {
      image = beePackage;
    } else if (this.currentItems[0].includes("oker")) {
      image = smoker;
    }
    this.noti.style.bottom = "30%";

    this.noti.style.height = "auto";
    this.noti.style.display = "block";

    this.noti.innerHTML = `
    ${image ? `<img class="large" src="${image}"/>` : ""}
    <p id="notification">${this.currentItems[0]} ${
      toDisplay > 1 ? `${toDisplay}x` : ""
    }</p>`;
    //if this single item is going to be displayed multiple times, delete the other instances of this item
    console.log("displayed gained. should delete it now");

    if (toDisplay > 1) {
      console.log("more than one todisplay gained: should delete the rest");
      for (let i = 0; i < this.currentItems.length; i++) {
        if (this.currentItems[i] == this.currentItems[0]) {
          console.log("deleting gained");
          this.currentItems.splice(i, 1);
        }
      }
    }
    this.currentItems.splice(0, 1);
    setTimeout(() => {
      console.log(
        "inside gained settimeout: currentItems: ",
        this.currentItems
      );
      this.noti.style.bottom = "-800px";
      this.noti.style.display = "none";
      this.noti.classList.remove("showingGained");
      this.displaying = false;
      if (this.currentItems.length > 0) {
        setTimeout(() => {
          this.displayItem();
        }, 300);
      }
    }, 2000);
  }
}
